import { FunctionalComponent } from 'preact'
import Phrase from '../../libs/translationsUtils/phrase'
import { GetServerSideProps } from '../../server-middleware/context'
import { z } from 'zod'

export const widgetName = 'introduction_bar'

export const config = z.any()

export const getServerSideProps: GetServerSideProps<unknown, {}> = async (_context, _config) => {
  return {}
}

const IntroductionBar: FunctionalComponent = () => {
  return (
    <section class='full-width Template-brand-cta is-transition--height custom-intro-bar' data-component='close-element' data-data={JSON.stringify({ storageName: 'close--widget-cta', parent: '.Template-brand-cta' })}>
      <div class='cta-widget qa-cta-widget'>
        <div class='sitewidth'>
          <span class='icon icon--cross icon--auto-width close js-close--element' aria-hidden='true' />
          <div class='col'>

            <div class='box widget widget--cta'>
              <div class='box__content box__pad'>

                <ul class='list list--float'>
                  <li class='list__item'>
                    <span class='icon icon--replace icon--round icon--checkmark' aria-hidden='true' />
                    <div class='list--label'><Phrase printRaw p='branded.cta.intro.first' /></div>
                  </li>
                  <li class='list__item'>
                    <span class='icon icon--replace icon--round icon--checkmark' aria-hidden='true' />
                    <div class='list--label'><Phrase printRaw p='branded.cta.intro.second' /></div>
                  </li>
                  <li class='list__item'>
                    <span class='icon icon--replace icon--round icon--checkmark' aria-hidden='true' />
                    <div class='list--label'><Phrase printRaw p='branded.cta.intro.third' /></div>
                  </li>
                </ul>
                <a href='/topic/new' data-track={JSON.stringify({ trigger: 'widget', type: 'Topic Initiated' })} data-ga-track={JSON.stringify({ eventCategory: 'Homepage', eventAction: 'Create topic clicked', eventLabel: { Position: 'Introduction widget' } })} class='btn--cta btn--new-topic qa-topic-new-button'><Phrase p='Ask your question' /></a>

              </div>

            </div>            </div>
        </div>
      </div>
    </section>
  )
}

export default IntroductionBar
